export enum EncounterDrawerFormsStack {
  CREATE_NEW_ENCOUNTER = "create-new-encounter",
  CREATE_EPISODE_OF_CARE = "create-episode-of-care",
}

export enum NewbornIPPEncounterDrawerFormsStack {
  BIRTH_DETAILS = "birth-details",
  SIZE = "size",
  VITALS_SIGN = "vitals-sign",
  FEEDING = "feeding",
  MEDICATIONS_THERAPIES = "medications-therapies",
  GESTATIONAL_AGE = "gestational-age",
  FILES = "files",
  CPT_CODE = "cpt-code",
}

export enum NewbornPostpartumEncounterDrawerFormsStack {
  SIZE = "size",
  VITALS_SIGN = "vitals-sign",
  MEDICATIONS_THERAPIES = "medications-therapies",
  INPUTS_OUTPUTS = "inputs-outputs",
  STATE_OF_NEWBORN = "state-of-newborn",
  FILES = "files",
  CPT_CODE = "cpt-code",
}

export enum TransferOfCareEncounterDrawerFormsStack {
  CLIENT_INFORMATION = "client-information",
  TRANSFER_PROVIDER_INFORMATION = "transfer-provider-information",
  RECEIVING_PROVIDER_INFORMATION = "receiving-provider-information",
  TRANSFER_DETAILS = "transfer-details",
  FILES = "files",
}

export enum PostpartumEncounterDrawerFormsStack {
  FEEDING = "feeding",
  LOCHIA = "lochia",
  OUTPUT = "output",
  ACTIVITY_NUTRITION = "activity-nutrition",
  SLEEP = "sleep",
  SOCIAL_HEALTH = "social-health",
  EMOTIONAL_HEALTH = "emotional-health",
  SEXUAL_ACTIVITY = "sexual-activity",
  MEDICATIONS_THERAPIES = "medications-therapies",
  VITALS = "vitals",
  FILES = "files",
  CPT_CODE = "cpt-code",
}

export enum DefaultEncounterDrawerFormsStack {
  FILES = "files",
  CPT_CODE = "cpt-code",
}

export enum GynecologicalEncounterDrawerFormsStack {
  VITALS_SIGN = "vitals-sign",
}
